import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import Loading from 'component/loading.component';

import * as articlesActions from 'store/action/articles.action';
import ArticleItem from './article.item.component';
import { toast } from 'react-toastify';

class ArticleList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loadMore: false,
      page: 1,
    };
  }

  componentDidMount() {
    this.props.resetArticles();
    this._loadArticles();
  }

  _loadArticles = () => {
    return this.props
      .fetchArticles(this.state.page)
      .then(data => {
        this.setState({
          loadMore: data.articles.length > 0,
          page: this.state.page + 1,
        });
      })
      .catch(e => {
        toast.error('Ocorreu um erro buscando os artigos.');
        this.setState({
          loadMore: false,
          page: this.state.page,
        });
      });
  };

  render() {
    const { resetArticleComments, articles } = this.props;
    return (
      <InfiniteScroll
        className="container relative"
        pageStart={1}
        loadMore={this._loadArticles}
        hasMore={this.state.loadMore}
        loader={<Loading key={0} />}
      >
        {articles.length > 0 &&
          articles.map((item, index) => (
            <ArticleItem
              key={item.id}
              article={item}
              reverse={parseInt(index) % 2 !== 0}
              resetArticleComments={resetArticleComments}
            />
          ))}
      </InfiniteScroll>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchArticles: page => dispatch(articlesActions.fetchArticles(page)),
    resetArticles: () => dispatch(articlesActions.resetArticles()),
    //subscribeNewsletter: email => dispatch(subscribeNewsletter(email)),
    resetArticleComments: () =>
      dispatch(articlesActions.resetArticleComments()),
  };
};

function mapStateToProps({ articles }) {
  return {
    articles,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleList);
